// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import views from './views';

export default {
    views
};



// WEBPACK FOOTER //
// ./reducers/index.js